function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.9765 25.4898C15.2678 25.7737 15.7322 25.7737 16.0235 25.4898L21.5104 20.1421C22.6992 18.9835 23.5087 17.5074 23.8367 15.9004C24.1646 14.2934 23.9963 12.6277 23.353 11.114C22.7096 9.60025 21.6201 8.30643 20.2223 7.39614C18.8245 6.48586 17.1811 6 15.5 6C13.8189 6 12.1755 6.48586 10.7777 7.39614C9.37985 8.30643 8.29039 9.60025 7.64704 11.114C7.00369 12.6277 6.83536 14.2934 7.16332 15.9004C7.49129 17.5074 8.30082 18.9835 9.48956 20.1421L14.9765 25.4898ZM15.5 20C14.0413 20 12.6424 19.4205 11.6109 18.3891C10.5795 17.3576 10 15.9587 10 14.5C10 13.0413 10.5795 11.6424 11.6109 10.6109C12.6424 9.57946 14.0413 9 15.5 9C16.9587 9 18.3576 9.57946 19.3891 10.6109C20.4205 11.6424 21 13.0413 21 14.5C21 15.9587 20.4205 17.3576 19.3891 18.3891C18.3576 19.4205 16.9587 20 15.5 20Z"
});

var SvgMap = function SvgMap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Map.b5d03ec3.svg";
export { ForwardRef as ReactComponent };